var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.contentOnly
    ? _c(
        "div",
        {
          staticClass: "alocacao-estrategica az-card-bordered",
          class: { "alocacao-estrategica--loading": _vm.loading }
        },
        [
          !_vm.loading
            ? _c(
                "div",
                { staticClass: "alocacao-estrategica__header" },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "alocacao-estrategica__title az-ds-card-title"
                    },
                    [_vm._v(" Alocação Estratégica ")]
                  ),
                  _c("v-spacer"),
                  _c(
                    "div",
                    { staticClass: "d-flex align-center az-gap-large" },
                    [
                      _vm.hasSuggestedData
                        ? _c("BaseToggleButton", {
                            attrs: {
                              role: "group",
                              "aria-label": "Visão da alocação",
                              small: "",
                              buttonStyle: "flatGray",
                              options: _vm.ALOCACAO_VISAO_OPTIONS
                            },
                            model: {
                              value: _vm.viewMode,
                              callback: function($$v) {
                                _vm.viewMode = $$v
                              },
                              expression: "viewMode"
                            }
                          })
                        : _vm._e(),
                      _c("BaseToggleButton", {
                        attrs: {
                          role: "group",
                          "aria-label": "Classes exibidas",
                          small: "",
                          buttonStyle: "flatGray",
                          options: _vm.ALOCACAO_VAZIOS_OPTIONS
                        },
                        model: {
                          value: _vm.emptyMode,
                          callback: function($$v) {
                            _vm.emptyMode = $$v
                          },
                          expression: "emptyMode"
                        }
                      }),
                      _vm.$slots["agrupar-por"]
                        ? _c(
                            "div",
                            { staticClass: "alocacao-estrategica__agrupar" },
                            [_vm._t("agrupar-por")],
                            2
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "FeedbackWrapper",
            {
              attrs: {
                loading: _vm.loading,
                noData: !_vm.hasData,
                message: _vm.WALLET_EMPTY_MESSAGE,
                minHeight: 425
              }
            },
            [
              _c("div", { staticClass: "alocacao-estrategica__content" }, [
                _c(
                  "div",
                  {
                    staticClass: "alocacao-estrategica__chart-scroll",
                    class: {
                      "alocacao-estrategica__chart-scroll--active":
                        _vm.shouldScrollChart
                    }
                  },
                  [
                    _c("AlocacaoEstrategicaChartBody", {
                      attrs: {
                        hasData: _vm.hasData,
                        chartData: _vm.chartData,
                        height: _vm.chartHeight
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "alocacao-estrategica__content-right" },
                  [
                    _c("div", { staticClass: "alocacao-estrategica__total" }, [
                      _c(
                        "div",
                        {
                          staticClass: "az-text-primary az-size-14 font-medium"
                        },
                        [_vm._v("Total")]
                      ),
                      _c(
                        "div",
                        { staticClass: "az-text-primary az-size-14 font-bold" },
                        [_vm._v(" " + _vm._s(_vm.total) + " ")]
                      )
                    ])
                  ]
                )
              ]),
              _c(
                "div",
                { staticClass: "info-adicional" },
                [_vm._t("info-adicional")],
                2
              )
            ]
          )
        ],
        1
      )
    : _c("AlocacaoEstrategicaChartBody", {
        attrs: { hasData: _vm.hasData, chartData: _vm.chartData, noPadding: "" }
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }